import { GUI } from "./GUI";
import { HUD } from "./HUD";
import { PauseLayer } from "./PauseLayer";
import { FinalLayer } from "./FinalLayer";
import { StageContainer } from "./StageContainer";
import { RoadManager } from "./Roadmanager";
import { ChickenManager } from "./chickens/ChickenManager";
import { BackgroundContainer } from "../BackgroundContainer";
import { Bug } from "../../utils/Bug";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { ControlsInstructionsLayer } from "./ControlsInstructionsLayer";

    export class RoadState extends Phaser.State {

        public static currentInstance: RoadState;  

        private gui: GUI;
        private hud: HUD;
        private pauseLayer: PauseLayer;
        private finalLayer: FinalLayer;
        private stageContainer: StageContainer;
        private resetKey: Phaser.Key;
        private desktopInstructions: ControlsInstructionsLayer;

        public init(): void {
            
            RoadState.currentInstance = this;

            RoadManager.init(this.game);
            ChickenManager.init(this.game);
        }
        
        public create(): void {

            const background = new BackgroundContainer(this.game);
            this.add.existing(background);

            this.stageContainer = new StageContainer(this.game);
            this.add.existing(this.stageContainer);

            this.hud = new HUD(this.game);
            this.add.existing(this.hud);

            this.gui = new GUI(this.game);
            this.add.existing(this.gui);

            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {
                this.resetKey = this.game.input.keyboard.addKey(Phaser.Keyboard.R);
            }

            if (Math.random() > .995) {
                let bug = new Bug(this.game);
                this.add.existing(bug);
            }

            if(this.game.device.desktop && !GameVars.gameData.desktopTutorialSeen) {
                this.desktopInstructions = new ControlsInstructionsLayer(this.game);
                this.add.existing(this.desktopInstructions);
            } else {
                this.desktopInstructions = null;
            }

            AudioManager.playSound("music_ingame", true, .3);
        }

        public shutdown(): void {
            
            RoadState.currentInstance = null;

            super.shutdown();
        }

        public update(): void {

            super.update();

            ChickenManager.update();
            
            if (!/Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile/i.test(navigator.userAgent)) {

                if (this.resetKey.justDown) {
                    GameManager.reset();
                }
            }
        }

        public removeInstructionsLayer() {

            this.desktopInstructions.destroy();
        }

        public render(): void {

            if (GameConstants.SHOW_PHYSICS_BODIES) {

                if (this.stageContainer.chicken) {
                    this.game.debug.body(this.stageContainer.chicken.chickenSprite);
                }

                const cars = this.stageContainer.cars;

                for (let i = 0; i < cars.length; i++) {
                    this.game.debug.body(cars[i]);
                }

                const ragdolls = this.stageContainer.ragdolls;

                for (let i = 0; i < ragdolls.length; i++) {
                    this.game.debug.body(ragdolls[i]);
                }

                const feather = this.stageContainer.feather;
                this.game.debug.body(feather.sprite);

                const trunks = this.stageContainer.trunks;

                for (let i = 0; i < trunks.length; i++) {
                    this.game.debug.body(trunks[i]);
                }
            }

            if (GameConstants.SHOW_FPS) {
                this.game.debug.text("FPS: " + this.game.time.fps , 10, 20, "#00ff00");
            }
        }

        public onChickenSaved(x: number, y: number, points: number): void {

            this.stageContainer.onChickenSaved();
            this.hud.onChickenSaved(x, y, points);

            AudioManager.playSound("yipee_0");
        }

        public onChickenDrowned(): void {

            this.stageContainer.onChickenDrowned(); 
        }

        public onChickenHit(x: number, y: number): void {

            this.hud.onChickenHit(x, y);
        }

        public moveChicken(x: number, y: number) {

            if (GameVars.gameOver) {
                return;
            }

            this.stageContainer.chicken.move(x, y);
        }

        public onCloseCall(x: number, y: number): void {

            this.hud.closeCall(x, y);
        }

        public showPauseLayer(): void {
            
            this.pauseLayer = new PauseLayer(this.game);
            this.add.existing(this.pauseLayer);
        }

        public hidePauseLayer(): void {
            
            this.pauseLayer.destroy();
            this.pauseLayer = null;
        }

        public showFinalLayer(): void {

            this.finalLayer = new FinalLayer(this.game);
            this.add.existing(this.finalLayer);
        }

        public switchdPad(): void {

            this.gui.switchdPad();
        }

        public featherPicked(): void {
            
            this.hud.showBootsTimer(this.stageContainer.chicken.x, this.stageContainer.chicken.y);

            AudioManager.playSound("get_feather");
        }
    }
